/**
 * This serves as a proxy to the react-pdf stuff. So that we can configure it differently depending on how
 * we are using it. For example, in webpack with worker-loader or file-loader.
 */

/* eslint-disable */

/* global PDFJS_CMAP_PATH, __webpack_public_path__ */
export { Document, Page, Outline } from 'react-pdf';
import { pdfjs } from 'react-pdf';
pdfjs.GlobalWorkerOptions.workerSrc = "//cdnjs.cloudflare.com/ajax/libs/pdf.js/" + pdfjs.version + "/pdf.worker.js";
export var options = {
  cMapUrl: "//cdn.jsdelivr.net/npm/pdfjs-dist@" + pdfjs.version + "/cmaps/",
  cMapPacked: true
};